import React from 'react';

const PrivacyPolicy = () => {
  const styles = {
    container: {
      backgroundColor: '#000000',
      color: '#ffffff',
      minHeight: '100vh',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      lineHeight: '1.6',
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '40px 20px',
    },
    h1: {
      fontSize: '2.5rem',
      marginBottom: '10px',
      fontWeight: '700',
    },
    lastUpdated: {
      color: '#888888',
      fontSize: '0.9rem',
      marginBottom: '30px',
    },
    h2: {
      fontSize: '1.8rem',
      marginTop: '40px',
      marginBottom: '20px',
      fontWeight: '600',
    },
    h3: {
      fontSize: '1.4rem',
      marginTop: '30px',
      marginBottom: '15px',
      fontWeight: '600',
    },
    section: {
      marginBottom: '30px',
    },
    paragraph: {
      marginBottom: '15px',
      fontSize: '1rem',
    },
    list: {
      marginLeft: '30px',
      marginBottom: '15px',
    },
    listItem: {
      marginBottom: '10px',
    },
    link: {
      color: '#4a9eff',
      textDecoration: 'none',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.h1}>Privacy Policy for ConfesZ</h1>
        <p style={styles.lastUpdated}>Last updated: October 6, 2025</p>

        <div style={styles.section}>
          <p style={styles.paragraph}>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>
          <p style={styles.paragraph}>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
          </p>
        </div>

        <h2 style={styles.h2}>Interpretation and Definitions</h2>
        
        <h3 style={styles.h3}>Interpretation</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>
        </div>

        <h3 style={styles.h3}>Definitions</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>For the purposes of this Privacy Policy:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li style={styles.listItem}><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
            <li style={styles.listItem}><strong>Application</strong> refers to ConfesZ, the software program provided by the Company.</li>
            <li style={styles.listItem}><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to ConfesZ.</li>
            <li style={styles.listItem}><strong>Country</strong> refers to: Turkey</li>
            <li style={styles.listItem}><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
            <li style={styles.listItem}><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li style={styles.listItem}><strong>Service</strong> refers to the Application.</li>
            <li style={styles.listItem}><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used, including third-party advertising networks such as Google AdMob.</li>
            <li style={styles.listItem}><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
            <li style={styles.listItem}><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
          </ul>
        </div>

        <h2 style={styles.h2}>Collecting and Using Your Personal Data</h2>
        
        <h3 style={styles.h3}>Types of Data Collected</h3>
        
        <h3 style={styles.h3}>Personal Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Email address</li>
            <li style={styles.listItem}>Advertising ID (for personalized advertisements)</li>
            <li style={styles.listItem}>Usage Data</li>
          </ul>
        </div>

        <h3 style={styles.h3}>Usage Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>Usage Data is collected automatically when using the Service.</p>
          <p style={styles.paragraph}>
            Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
          </p>
          <p style={styles.paragraph}>
            When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
          </p>
          <p style={styles.paragraph}>
            We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
          </p>
        </div>

        <h3 style={styles.h3}>Advertising and Third-Party Services</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            Our Service uses Google AdMob to display advertisements. AdMob may use cookies and similar technologies to collect information about your device and usage patterns to provide personalized advertising.
          </p>
          <p style={styles.paragraph}><strong>Information collected by AdMob may include:</strong></p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Device information (device type, operating system, device identifiers)</li>
            <li style={styles.listItem}>IP address and general location information</li>
            <li style={styles.listItem}>Ad interaction data</li>
            <li style={styles.listItem}>App usage information</li>
          </ul>
          <p style={styles.paragraph}>
            For personalized ads, Google may use this information to show you more relevant advertisements based on your interests.
          </p>
          <p style={styles.paragraph}>
            You can learn more about how Google uses data when you use our app by visiting: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" style={styles.link}>https://policies.google.com/technologies/partner-sites</a>
          </p>
          <p style={styles.paragraph}><strong>To opt out of personalized advertising, you can:</strong></p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Adjust your device's advertising settings (iOS: Settings &gt; Privacy &gt; Advertising; Android: Settings &gt; Google &gt; Ads)</li>
            <li style={styles.listItem}>Visit Google's Ads Settings at <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" style={styles.link}>https://adssettings.google.com</a></li>
          </ul>
        </div>

        <h3 style={styles.h3}>Use of Your Personal Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>The Company may use Personal Data for the following purposes:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</li>
            <li style={styles.listItem}><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</li>
            <li style={styles.listItem}><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</li>
            <li style={styles.listItem}><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</li>
            <li style={styles.listItem}><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</li>
            <li style={styles.listItem}><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</li>
            <li style={styles.listItem}><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</li>
            <li style={styles.listItem}><strong>For other purposes:</strong> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</li>
          </ul>
          <p style={styles.paragraph}>We may share Your personal information in the following situations:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</li>
            <li style={styles.listItem}><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
            <li style={styles.listItem}><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
            <li style={styles.listItem}><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
            <li style={styles.listItem}><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
            <li style={styles.listItem}><strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.</li>
          </ul>
        </div>

        <h3 style={styles.h3}>Retention of Your Personal Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
          </p>
          <p style={styles.paragraph}>
            The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
          </p>
        </div>

        <h3 style={styles.h3}>Transfer of Your Personal Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
          </p>
          <p style={styles.paragraph}>
            Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
          </p>
          <p style={styles.paragraph}>
            The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.
          </p>
        </div>

        <h3 style={styles.h3}>Delete Your Personal Data</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
          </p>
          <p style={styles.paragraph}>
            Our Service may give You the ability to delete certain information about You from within the Service.
          </p>
          <p style={styles.paragraph}>
            You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
          </p>
          <p style={styles.paragraph}>
            Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.
          </p>
        </div>

        <h2 style={styles.h2}>Disclosure of Your Personal Data</h2>
        
        <h3 style={styles.h3}>Business Transactions</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
          </p>
        </div>

        <h3 style={styles.h3}>Law Enforcement</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
          </p>
        </div>

        <h3 style={styles.h3}>Other Legal Requirements</h3>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Comply with a legal obligation</li>
            <li style={styles.listItem}>Protect and defend the rights or property of the Company</li>
            <li style={styles.listItem}>Prevent or investigate possible wrongdoing in connection with the Service</li>
            <li style={styles.listItem}>Protect the personal safety of Users of the Service or the public</li>
            <li style={styles.listItem}>Protect against legal liability</li>
          </ul>
        </div>

        <h2 style={styles.h2}>Security of Your Personal Data</h2>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
          </p>
        </div>

        <h2 style={styles.h2}>Children's Privacy</h2>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.
          </p>
          <p style={styles.paragraph}>
            If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.
          </p>
        </div>

        <h2 style={styles.h2}>Links to Other Websites</h2>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
          </p>
          <p style={styles.paragraph}>
            We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
          </p>
        </div>

        <h2 style={styles.h2}>Changes to this Privacy Policy</h2>
        <div style={styles.section}>
          <p style={styles.paragraph}>
            We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
          </p>
          <p style={styles.paragraph}>
            We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
          </p>
          <p style={styles.paragraph}>
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
          </p>
        </div>

        <h2 style={styles.h2}>Contact Us</h2>
        <div style={styles.section}>
          <p style={styles.paragraph}>If you have any questions about this Privacy Policy, You can contact us:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              By email: <a href="mailto:confesz@tech-center.com" style={styles.link}>confesz@tech-center.com</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;